import { Text } from "@mantine/core"
import { useSuspenseQueryGet } from "@/typed-client/hooks/use-suspense-query-get"
import { PersonName } from "@components/PersonName"
import { t } from "i18next"

export function ContractTitle({
  contractId,
  onTitleChange,
}: {
  contractId: number
  onTitleChange?: (title: string) => void
}) {
  const { data: contract } = useSuspenseQueryGet(
    "/api/Contracts/GetContractDetails",
    { id: contractId }
  )
  let title: string
  if (!contract) {
    title = t("DeletedOrNoPermission")
    onTitleChange?.(title)
    return (
      <Text span inherit>
        {title}
      </Text>
    )
  }
  title = `${contract.contractTypeName} ${contract.personId ? "" : ""}`.trim()
  React.useEffect(() => {
    onTitleChange?.(title)
  }, [title, onTitleChange])
  return (
    <Text span inherit>
      {contract.contractTypeName} <PersonName personId={contract.personId} />
    </Text>
  )
}
